module.exports = __webpack_public_path__ + "img/cooperate_38.02666336.png";